module.exports = __webpack_public_path__ + "img/logo.9b6e5ad3.gif";